const ObjectManager = {
    delete: (arr, property, value) => {
        return arr.filter(item => (item?.[property] || item) !== value)
    },
    getLastElement: arr => {
        return arr[arr.length - 1]
    }
}

export const isValidJson = jsonString => {
    try {
        JSON.parse(jsonString)
        return true
    } catch (error) {
        return false
    }
}

export const areArraysEqual = (arr1 = [], arr2 = []) => {
    if (arr1?.length !== arr2?.length) return false
    return arr1.every(item => arr2.includes(item)) && arr2.every(item => arr1.includes(item))
}

export const getImageSource = async(image) => {
    const imageSrc = await import(`../assets/images/${image}`)
    return imageSrc.default || null
}

export const groupDataByProperty = (data, property) =>
    data?.reduce((acc, item) => {
        const key = property
            .split('.')
            .reduce((nested, prop) => nested?.[prop], item)

        if (!key) return acc
        if (!acc[key]) acc[key] = []
        acc[key].push(item)
        return acc
    }, {})

export const flattenKeys = (obj, flattenArrays = true, prefix = '') => {
    if (typeof obj !== 'object' || obj === null) return []

    return Object.entries(obj).flatMap(([key, value]) => {
        const path = prefix ? `${prefix}.${key}` : key

        if (Array.isArray(value)) {
            if (flattenArrays) {
                return value.flatMap((item, index) => {
                    const arrayPath = `${path}.[${index}]`

                    return typeof item === 'object' && item !== null
                        ? flattenKeys(item, flattenArrays, arrayPath)
                        : [arrayPath]
                })
            }
            const first = value[0]
            return typeof first === 'object' && first !== null
                ? flattenKeys(first, flattenArrays, path)
                : [path]
        }

        if (typeof value === 'object' && value !== null) {
            return flattenKeys(value, flattenArrays, path)
        }

        return [path]
    })
}

export const getNestedValue = (obj, path) => {
    if (!path) return undefined
    const cleanedPath = path.replace(/\.\[/g, '[').replace(/\[(\d+)\]/g, '.$1')
    const keys = cleanedPath.split('.').filter(Boolean)

    return keys.reduce((acc, key) => {
        if (acc === null || acc === undefined) return undefined

        const index = Number(key)
        if (!isNaN(index) && Array.isArray(acc)) {
            return acc[index]
        }

        return acc[key]
    }, obj)
}

export default ObjectManager
